<template>
  <ulTemplate v-if="!content.templateType || content.templateType === 1" :content="content"></ulTemplate>
</template>
<script>
/*
列表组件
*/
import ulTemplate from "./ul.vue";

export default {
  name: "listIndex",
  components: {
    ulTemplate,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.content_w_710 {
  width: calc(100% - 48rem);
  margin: 0 auto 20px;
}
</style>